// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyB4Nov9brIhP6oiGOAibEBvFws_Nxvhx5A',
    authDomain: 'ottoti.firebaseapp.com',
    databaseURL: 'https://ottoti.firebaseio.com',
    projectId: 'ottoti',
    storageBucket: 'ottoti.appspot.com',
    messagingSenderId: '386464202956',
    appId: '1:386464202956:web:997e35158026367b61c269',
    measurementId: 'G-1ZWZQQ1V1X'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
